import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useFunctions, useRefs } from '../hooks';
import { FullscreenWrapper } from '../wrappers';

import { useLocation } from 'react-router-dom';
import { getLocationParams } from '../util';

// Custom imports:
import { Group, Text, Image, Input } from '../components';
import oip from '../assets/oip.jpg';
import { useTranslation } from 'react-i18next';

export const Coach2View = () => {
  const { run } = useFunctions();
  const { search, pathname } = useLocation();


  // Custom exports:
	const { t } = useTranslation();

  // Custom functions:
	const textseguirOnClick = async (options) => {
		run([{"id":"set1678519513937","function":"set","what":"@property.pagcoach2","value":"dos","if":{"what":"@property.pagcoach2","is":"uno","else":[{"id":"set1678806622897","function":"set","what":"@property.pagcoach2","value":"tres","if":{"what":"@property.pagcoach2","is":"dos","else":[{"id":"set1678806840422","function":"set","what":"@property.pagcoach2","value":"cuatro","if":{"what":"@property.pagcoach2","is":"tres","else":[{"id":"set1678806914012","function":"set","what":"@property.pagcoach2","value":"cinco","if":{"what":"@property.pagcoach2","is":"cuatro","and":{"what":"@cookie.authTermsAccepted","is":true},"else":[{"id":"set1678897881837","function":"set","what":"@property.authMessage","value":"terms"},{"id":"popup1678897864716","function":"popup","dialog":"auth_dialog_1"}]}}]}}]}}]}},{"id":"set1678820726475","function":"set","what":"@property.arroba","value":"@"},{"id":"signup1678808289559","function":"signup","provider":"firebase","email":"@property.authEmail","pass":"@property.authPassword","onvalid":[{"id":"set1678808423001","function":"set","what":"@cookie.userID","value":"@firebase.user.id"},{"id":"add1678808423001","function":"add","what":{"nombre":"@property.authName","email":"@property.authEmail","foto":"(@property.arroba)firebase.storage.usuarios\/(@firebase.user.id)\/foto.png","idusuario":"@firebase.user.id","type":"marker"},"to":"@firebase.firestore.usuarios","key":"@firebase.user.id"},{"id":"set1685432782804","function":"set","what":"@firebase.firestore.usuarios.(@cookie.userID).soycomprador","value":true,"if":{"what":"@cookie.formulario","is":"comprador"}},{"id":"set1685432858891","function":"set","what":"@firebase.firestore.usuarios.(@cookie.userID).soyvendedor","value":true,"if":{"what":"@cookie.formulario","is":"vendedor"}},{"id":"goto1678808423001","function":"goto","view":"auth_destination"}],"if":{"what":"@property.pagcoach2","is":"cinco"},"oninvalid":[{"id":"set1678897206989","function":"set","what":"@property.authMessage","value":"signin"},{"id":"popup1678897158403","function":"popup","dialog":"auth_dialog_1"}],"onexists":[{"id":"set1678897256428","function":"set","what":"@property.authMessage","value":"exists"},{"id":"popup1678897256428","function":"popup","dialog":"auth_dialog_1"}],"onweakpassword":[{"id":"set1678897300157","function":"set","what":"@property.authMessage","value":"weak"},{"id":"popup1678897300157","function":"popup","dialog":"auth_dialog_1"}]}], options)
	}
	const authTermsLink1678466674101OnClick = async (options) => {
		run([{"function":"popup","dialog":"auth_terms_1"}], options)
	}

  return (
    <>
      <Helmet>
				<title>{t('coach2.title')}</title>
      </Helmet>
      <FullscreenWrapper>
          
			<Group
				id="grupoinicio1678398947813"
				direction="vertical"
				className="w-100 h-fill position-relative" >
				<Text
					id="text1678398947812"
					className="w-100 h-fill valign-end position-relative" >
					{t('coach2.text1678398947812')}
				</Text>
				<Group
					id="gruponombre"
					if={{"what":"@property.pagcoach2","is":"uno"}}
					direction="vertical"
					className="w-100 h-auto position-relative" >
					<Group
						id="grupopregunta1678398947813"
						direction="horizontal"
						className="max-w-900px w-90 h-auto align-center position-relative p-3px" >
						<Image
							id="image1678398947812"
							src={oip}
							className="w-15 h-auto border-radius-40px align-center valign-center position-relative m-20px" />
						<Group
							id="group1678398947813"
							direction="vertical"
							className="w-auto h-auto border-radius-30px valign-center position-relative bg-primary-light-to-primary-dark" >
							<Text
								id="text1678485483373"
								className="w-auto h-auto border-radius-20px align-center position-relative p-20px text-text-on-accent f-15px text-center" >
								{t('coach2.text1678485483373')}
							</Text>
						</Group>
					</Group>
					<Group
						id="grupopregunta1678465894749"
						direction="horizontal"
						className="max-w-450px w-90 h-auto align-center position-relative p-3px" >
						<Input.Text
							id="authSignupNameInput1678465851459"
							name="signupName"
							src="@property.authName"
						placeholder={t('coach2.authSignupNameInput1678465851459.hint')}
						autoComplete="off"
							className="w-100 h-auto align-center valign-center position-relative" />
					</Group>
				</Group>
				<Group
					id="grupoemail"
					if={{"what":"@property.pagcoach2","is":"dos"}}
					direction="vertical"
					className="w-100 h-auto position-relative m-10px" >
					<Group
						id="grupopregunta1678466215079"
						direction="horizontal"
						className="max-w-900px w-90 h-auto align-center position-relative p-3px" >
						<Image
							id="image1678466215079"
							src={oip}
							className="w-15 h-auto border-radius-40px align-center valign-center position-relative m-20px" />
						<Group
							id="group1678466215079"
							direction="vertical"
							className="w-auto h-auto border-radius-30px valign-center position-relative" >
							<Text
								id="text1678466215079"
								className="w-auto h-auto border-radius-20px align-center position-relative bg-primary-light-to-primary-dark p-20px text-text-on-primary f-15px text-center" >
								{t('coach2.text1678466215079')}
							</Text>
						</Group>
					</Group>
					<Group
						id="grupopregunta1678466215079"
						direction="horizontal"
						className="max-w-450px w-90 h-auto align-center position-relative p-3px" >
						<Input.Email
							id="authLoginEmailInput1678467624018"
							name="loginEmail"
							src="@property.authEmail"
						placeholder={t('coach2.authLoginEmailInput1678467624018.hint')}
						autoComplete="off"
							className="w-100 h-auto position-relative" />
					</Group>
				</Group>
				<Group
					id="groupopasword"
					if={{"what":"@property.pagcoach2","is":"tres"}}
					direction="vertical"
					className="w-100 h-auto position-relative m-10px" >
					<Group
						id="grupopregunta1678466325444"
						direction="horizontal"
						className="max-w-900px w-90 h-auto align-center position-relative p-3px" >
						<Image
							id="image1678466325443"
							src={oip}
							className="w-15 h-auto border-radius-40px align-center valign-center position-relative m-20px" />
						<Group
							id="group1678466325444"
							direction="vertical"
							className="w-auto h-auto border-radius-30px valign-center position-relative bg-primary-light-to-primary-dark" >
							<Text
								id="text1678466325443"
								className="w-auto h-auto border-radius-20px align-center position-relative p-20px text-text-on-primary f-15px text-center" >
								{t('coach2.text1678466325443')}
							</Text>
						</Group>
					</Group>
					<Group
						id="grupopregunta1678466325444"
						direction="horizontal"
						className="max-w-450px w-90 h-auto align-center position-relative p-3px" >
						<Input.Password
							id="authSignupPasswordInput1678466440526"
							name="loginEmail"
							src="@property.authPassword"
						placeholder={t('coach2.authSignupPasswordInput1678466440526.hint')}
						autoComplete="off"
							className="w-100 h-auto position-relative mt-24px" />
					</Group>
				</Group>
				<Group
					id="grupopoliticas"
					if={{"what":"@property.pagcoach2","is":"cuatro"}}
					direction="vertical"
					className="w-100 h-auto position-relative m-10px" >
					<Group
						id="grupopregunta1678466525999"
						direction="horizontal"
						className="max-w-900px w-90 h-auto align-center position-relative p-3px" >
						<Image
							id="image1678466525999"
							src={oip}
							className="w-15 h-auto border-radius-40px align-center valign-center position-relative m-20px" />
						<Group
							id="group1678466525999"
							direction="vertical"
							className="w-auto h-auto border-radius-30px valign-center position-relative bg-primary-light-to-primary-dark" >
							<Text
								id="text1678466525999"
								className="w-auto h-auto border-radius-20px align-center position-relative p-20px text-text-on-primary f-15px text-center" >
								{t('coach2.text1678466525999')}
							</Text>
						</Group>
					</Group>
					<Group
						id="grupopregunta1678466525999"
						direction="horizontal"
						className="max-w-450px w-90 h-auto align-center position-relative p-3px" >
						<Group
							id="authTermsGroup1678466674101"
							direction="horizontal"
							className="w-auto h-auto align-center position-relative p-8px mt-16px" >
							<Input.Switch
								id="authTermsSwitch1678466674101"
								name="switch"
								src="@cookie.authTermsAccepted"
								className="w-auto h-auto position-relative" />
							<Text
								id="authTermsLabel1678466674101"
								className="w-auto h-auto position-relative pe-4px text-primary-text ff-auth" >
								{t('coach2.authTermsLabel1678466674101')}
							</Text>
							<Text
								id="authTermsLink1678466674101"
								onClick={authTermsLink1678466674101OnClick}
								className="w-auto h-auto position-relative pe-4px text-primary-light ff-auth" >
								{t('coach2.authTermsLink1678466674101')}
							</Text>
						</Group>
					</Group>
				</Group>
				<Text
					id="text1678398947813"
					className="w-100 h-fill align-center valign-end position-relative text-center" >
					{t('coach2.text1678398947813')}
				</Text>
				<Text
					id="textseguir"
					onClick={textseguirOnClick}
					className="max-w-350px w-100 h-auto border-radius-10px align-center position-relative bg-accent py-8px mt-32px text-text-on-accent ff-auth_regular text-center" >
					{t('coach2.textseguir')}
				</Text>
				<Text
					id="text1678398947813"
					className="w-100 h-fill align-center valign-end position-relative m-10px text-center" >
					{t('coach2.text1678398947813')}
				</Text>
				<Text
					id="text1678804758280"
					className="w-100 h-auto position-relative" >
				</Text>
			</Group>
			<Text
				id="text1678475147527"
				className="w-100 h-auto position-relative" >
				{t('coach2.text1678475147527')}
			</Text>
      </FullscreenWrapper>
    </>
  );
};
